import { render, staticRenderFns } from "./CannotCoachHeightJP.vue?vue&type=template&id=795cc664"
import script from "./CannotCoachHeightJP.vue?vue&type=script&lang=js"
export * from "./CannotCoachHeightJP.vue?vue&type=script&lang=js"
import style0 from "./CannotCoachHeightJP.vue?vue&type=style&index=0&id=795cc664&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports